module.exports = __webpack_public_path__ + "media/images/logo_fundeim_white-15cf2129.svg";